import { SVGProps } from "react";

export const Logout1Icon = ({
  color = "currentColor",
  size = 16,
  strokeWidth = 1,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg width={size} height={size} {...rest} fill="none" viewBox="0 0 24 24">
      <path
        fill="none"
        d="M3.5 15.5V18l10 5.5 10 -5.5V7l-10 -5.5L3.5 7v2.5"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M21.385 16.663 13.5 21l-7.885 -4.337L3.5 18l10 5.5 10 -5.5 -2.115 -1.337Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0.5 12.5H16"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m12 8.5 4 4 -4 4"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.5 15.5V18l10 5.5 10 -5.5V7l-10 -5.5L3.5 7v2.5"
        strokeWidth={strokeWidth}
      ></path>
    </svg>
  );
  return render();
};
